import React, { useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import "./PremiumCheckoutResult.scss";

import PremiumCheckoutHeader from "./PremiumCheckoutHeader";
import {
    maskEmailForBanner,
    readEmailFromSearch,
} from "./premiumCheckoutConfig";

const openAppDeepLink = () => {
    const url = process.env.REACT_APP_UNIVERSAL_DEEP_LINK;
    if (url) {
        window.location.assign(url);
    } else {
        console.error("Missing REACT_APP_UNIVERSAL_DEEP_LINK");
    }
};

const PremiumCheckoutOops: React.FC = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const stateEmail =
        (location.state as { email?: string } | null)?.email ?? null;

    const rawEmail = useMemo(() => {
        return readEmailFromSearch(searchParams) || stateEmail;
    }, [searchParams, stateEmail]);

    const emailDisplay = rawEmail ? maskEmailForBanner(rawEmail) : "";

    return (
        <section
            className="PremiumCheckoutResult"
            aria-label="Already Premium"
        >
            <PremiumCheckoutHeader emailDisplay={emailDisplay} />

            <div className="PremiumCheckoutResult__content PremiumCheckoutResult__content--oops">
                <h1 className="PremiumCheckoutResult__title">Oops!</h1>
                <p className="PremiumCheckoutResult__message">
                    It looks like your account is already Premium.
                </p>

                <button
                    className="PremiumCheckoutResult__cta"
                    type="button"
                    onClick={openAppDeepLink}
                >
                    Open Instant Heart Rate
                </button>
            </div>
        </section>
    );
};

export default PremiumCheckoutOops;
